import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
var _excluded = ["className"];
import * as React from 'react';
import clsx from 'clsx';
import { jsx as _jsx } from "react/jsx-runtime";
var Send03 = _ref => {
  var {
      className
    } = _ref,
    props = _objectWithoutPropertiesLoose(_ref, _excluded);
  return /*#__PURE__*/_jsx("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: "100%",
    height: "100%",
    fill: "none",
    viewBox: "0 0 24 24",
    "data-testid": "send03",
    className: clsx('stroke-current', className)
  }, props, {
    children: /*#__PURE__*/_jsx("path", {
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 2,
      d: "M10.5004 12h-5.5m-.0846.2915-2.335 6.9747c-.1834.548-.2751.8219-.2093.9907a.4998.4998 0 0 0 .3314.2998c.1745.0487.438-.0698.9649-.307l16.7114-7.5201c.5144-.2315.7715-.3472.851-.508a.4997.4997 0 0 0 0-.4432c-.0795-.1607-.3366-.2765-.851-.5079L3.6619 3.7478c-.5253-.2364-.788-.3546-.9622-.3062a.5.5 0 0 0-.3315.2992c-.066.1684.0247.4417.2062.9885l2.342 7.0563c.0312.0939.0468.1408.053.1888a.5003.5003 0 0 1-.0002.1284c-.0063.048-.022.0949-.0534.1887Z"
    })
  }));
};
export default Send03;